// extracted by mini-css-extract-plugin
module.exports = {"Sidebar":"Sidebar_Sidebar__3NeLW"};